import { type FC, type ReactNode, useLayoutEffect } from 'react';
import { useSettings } from '@/settings/api';
import { isStandalone } from '@/shared/js';

export const useIsDark = () => {
  const [settings] = useSettings();
  return settings.theme === 'auto'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : settings.theme === 'dark';
};

export const ThemeProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const isDark = useIsDark();

  useLayoutEffect(() => {
    document.documentElement.classList[isDark ? 'add' : 'remove']('dark');
    if (isStandalone()) {
      document.head
        .querySelector('meta[name="viewport"]')
        ?.setAttribute(
          'content',
          'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover, shrink-to-fit=no, interactive-widget=resizes-content',
        );
    }
  }, [isDark]);

  return <>{children}</>;
};
